import React from 'react'
import { useSelector } from 'react-redux'

import ModalLayout from '@/app/component/layout/modal'
import { selectToken } from '@/app/module/auth/store/selectors'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { selectCountriesMapped } from '@/app/module/utils/store/selectors'
import type { RootState } from '@/app/store'
import { useAppDispatch } from '@/app/store/redux-hooks'
import config from '@/config'

import Upload from './component/upload'
import type { UploadData, UploadError } from './component/upload/types'
import { confirmUpload, getUploadStatus, uploadContacts } from './store/actions'
import { selectContactsItemConfig } from './store/selectors'

type Props = {
  open: boolean
  onClose: () => void
}

const pageSizeDefault = config.modules.contacts.pageSize.default

const UploadContactsDialog: React.FC<Props> = ({ open, onClose }) => {
  const dispatch = useAppDispatch()
  const countriesList = useSelector(selectCountriesMapped)
  const loading = useSelector(
    ({ contacts, customFields }: RootState) => contacts.upload.loading || customFields.loading,
  )
  const orgId = useSelector(selectOrgId)
  const page = useSelector(({ contacts }: RootState) => contacts.list.data.page || 1)
  const size = useSelector(({ contacts }: RootState) => contacts.list.data.size || pageSizeDefault)
  const specs = useSelector(selectContactsItemConfig)
  const token = useSelector(selectToken)
  const uploadConfirmError = useSelector(
    ({ contacts }: RootState) => (contacts.upload.confirmError || {}) as UploadError,
  )
  const uploadData = useSelector((state: RootState) => (state.contacts.upload.data || {}) as UploadData)
  const uploadError = useSelector((state: RootState) => (state.contacts.upload.error || {}) as UploadError)

  return (
    <ModalLayout title="Upload contacts" isOpen={open} onClose={onClose}>
      <Upload
        countriesList={countriesList}
        loading={loading}
        orgId={orgId}
        page={page}
        size={size}
        specs={specs}
        token={token ?? ''}
        uploadData={uploadData}
        uploadError={uploadError}
        uploadConfirmError={uploadConfirmError}
        confirmUpload={(payload) => dispatch(confirmUpload(payload))}
        getUploadStatus={(payload) => dispatch(getUploadStatus(payload))}
        uploadContacts={(payload) => dispatch(uploadContacts(payload))}
      />
    </ModalLayout>
  )
}

export default UploadContactsDialog
